import { Component, ElementRef, HostListener, inject, signal, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

type AvailableLanguage = 'en' | 'de' | 'fr' | 'es' | 'zh';

@Component({
    selector: 'shig-sf-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class HeaderComponent {
    private readonly eRef = inject(ElementRef);
    private readonly router = inject(Router);
    private readonly translate = inject(TranslateService);

    protected readonly languageSelected = signal<AvailableLanguage>('en');
    protected readonly showLanguageSelection = signal<boolean>(false);

    protected readonly availableLanguages: readonly AvailableLanguage[] = ['en', 'de', 'fr', 'es', 'zh'];

    @HostListener('document:click', ['$event'])
    protected clickout(event: MouseEvent): void {
        if (!this.eRef.nativeElement.contains(event.target)) {
            this.showLanguageSelection.set(false);
        }
    }

    constructor() {
        this.initLanguage();
    }

    protected openLanguageSelection(): void {
        this.showLanguageSelection.set(!this.showLanguageSelection());
    }

    protected gotoStartPage(): void {
        this.router.navigate(['/']);
    }

    protected changeLanguage(lang: AvailableLanguage): void {
        this.languageSelected.set(lang);
        this.translate.use(lang);
        localStorage.setItem('language', lang);
    }

    private initLanguage(): void {
        const currLang = localStorage.getItem('language');

        if (currLang && this.availableLanguages.includes(currLang as AvailableLanguage)) {
            this.languageSelected.set(currLang as AvailableLanguage);
            this.translate.use(currLang as AvailableLanguage);
        } else {
            const browserLang = this.translate.getBrowserLang();
            const defaultLang = this.availableLanguages.includes(browserLang as AvailableLanguage)
                ? (browserLang as AvailableLanguage)
                : 'en';

            this.languageSelected.set(defaultLang);
            this.translate.use(defaultLang);
            localStorage.setItem('language', defaultLang);
        }
    }
}
